// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  attendanceId: __t.u64().primaryKey().name("attendance_id"),
  eventId: __t.u64().name("event_id"),
  identity: __t.identity(),
  escrowId: __t.u64().name("escrow_id"),
  sessionsAttended: __t.u32().name("sessions_attended"),
  checkedIn: __t.bool().name("checked_in"),
  lastSessionAt: __t.timestamp().name("last_session_at"),
  satisfactionRecorded: __t.bool().name("satisfaction_recorded"),
  satisfaction: __t.u8(),
  invitedAt: __t.timestamp().name("invited_at"),
  firstSeenAt: __t.timestamp().name("first_seen_at"),
});
